"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = exports.TextareaContainer = void 0;

var _index = require("../styles/index.js");

var _styledComponents = require("../input/styled-components.js");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TextareaContainer = (0, _index.styled)('div', function (props) {});
exports.TextareaContainer = TextareaContainer;
TextareaContainer.displayName = "TextareaContainer";
var Textarea = (0, _index.styled)('textarea', function (props) {
  return _objectSpread({}, (0, _styledComponents.getInputStyles)(props), (0, _styledComponents.getInputContainerStyles)(props));
});
exports.Textarea = Textarea;
Textarea.displayName = "Textarea";